<div class="project-card"*ngIf="vcu" [(style.display)]="cardClass">
  <div class="backgroundImg">
    <div class="project-image" [ngStyle]="{'background-image': formatImage(vcu.image?.href) }"></div>
  </div>
  <div class="project-info">
        <div class="project-header">
      <span class="project-user">VCU</span>
    </div>
    <h3 class="project-title">{{ vcu.surname }}</h3>
    <div class="project-header">
      <span class="project-user" *ngIf="!details"><p><i class="pi pi-circle-fill" [ngClass]="statusClass"></i> {{ descriptionStatus }}</p></span>
      
    </div>

    <div class="project-views" >
      <p-button *ngIf="showUnlink" class="black-btn" icon="pi pi-sort-alt-slash" (onClick)="unlinkVcu()" [disabled]="sharing"/>
      <p-button class="details-btn" (onClick)="goVcuDetail()" *ngIf="!details"><i class="pi pi-chevron-right"></i ></p-button>
    </div>
  </div>
</div>
<div class="polygon" [ngClass]="polygonClass" [(style.display)]="cardClass"></div>